/** Raised when an editing operation is not allowed. Messages are user-presentable. */
export class EditError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EditError';
  }
}

export function invariant(condition: unknown, message: string): asserts condition {
  if (!condition) throw new EditError(message);
}
